import { Typography } from '@mui/material';
import { format } from 'date-fns';

import type { DispatchSerialCheck } from '@/domain/izzi';

const fmtDate = (value: unknown) =>
  value ? format(new Date(value as string), 'dd/MM/yyyy HH:mm') : '—';

interface SerialCheckBannerProps {
  check: DispatchSerialCheck;
  label?: string;
}

export const SerialCheckBanner = ({ check, label }: SerialCheckBannerProps) => {
  const title =
    check.outcome === 'QUARANTINED'
      ? 'En cuarentena. No despachen esta serie.'
      : check.outcome === 'RELEASED'
        ? 'Liberada. Ya se puede usar.'
        : check.outcome === 'OK' || check.outcome === 'CLEAR'
          ? 'No está en cuarentena. Se puede usar.'
          : 'Esta serie no se puede usar.';

  const bannerClass =
    check.outcome === 'QUARANTINED'
      ? 'border-amber-400 bg-amber-50'
      : check.outcome === 'REJECTED' || check.outcome === 'ERROR'
        ? 'border-red-300 bg-red-50'
        : 'border-green-400 bg-green-50';

  return (
    <div className={`rounded-lg border p-4 ${bannerClass}`}>
      <Typography variant="subtitle2" fontWeight="bold">
        {label ? `${label}: ${title}` : title}
      </Typography>
      <Typography variant="body2" className="mt-1">
        Serie: {check.iccid}
        {check.purchaseOrder ? ` · PO: ${check.purchaseOrder}` : ''}
        {check.customerSO ? ` · SO: ${check.customerSO}` : ''}
        {check.sku ? ` · SKU: ${check.sku}` : ''}
      </Typography>
      {check.outcome === 'QUARANTINED' && check.quarantinedAt && (
        <Typography variant="body2" color="text.secondary">
          En cuarentena desde {fmtDate(check.quarantinedAt)}
        </Typography>
      )}
      {check.outcome === 'RELEASED' && check.releasedAt && (
        <Typography variant="body2" color="text.secondary">
          Liberada el {fmtDate(check.releasedAt)}
        </Typography>
      )}
      {check.izziMessage && (
        <Typography variant="body2" color="text.secondary" className="mt-1">
          {check.izziMessage}
        </Typography>
      )}
    </div>
  );
};
